import { render } from "./EmptyCard.vue?vue&type=template&id=5985cd28&scoped=true&ts=true"
import script from "./EmptyCard.vue?vue&type=script&lang=ts"
export * from "./EmptyCard.vue?vue&type=script&lang=ts"

import "./EmptyCard.vue?vue&type=style&index=0&id=5985cd28&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5985cd28"]])

export default __exports__